import {Avatar} from 'antd'
import classNames from 'classnames'
import getAvatar from 'helpers/getAvatar'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {Link} from 'react-router-dom'
import {RiUser2Fill} from "react-icons/ri";

export const ReportCreator = ({ style, className, creator, description }) => (
  <div
    style={style}
    className={classNames('flex items-center gap-2', className)}>
      <Avatar
          size={32}
          icon={<RiUser2Fill size={16} className="text-color-500"/>}
          src={getAvatar(creator)}
          className="flex flex-center background-200"
      />
      <div className="flex flex-col gap-1">
          <Link
              target="_blank"
              style={{ fontSize: '0.9rem' }}
              className="font-bold text-primary no-underline"
              to={getLinkToDetail(creator)}>
              {getTitle(creator)}
          </Link>
          {description && (
              <span className="text-xs text-color-500 italic">
                  {description}
              </span>
          )}
      </div>
  </div>
)

const MetaDescription = ({ style, title, className, children }) => {
  const t = useTranslate()
  return (
    <div
      style={style}
      className={classNames('flex flex-col', className)}>
      {_.isString(title) ? `${t(title)}: ` : title}
      {children}
    </div>
  )
}

const ErrorReportMeta = ({ item, style, className }) => (
  <div
    style={style}
    className={classNames('flex flex-col', className)}>
    <MetaDescription
      title="creator"
      className="p-2 border rounded">
      <ReportCreator creator={item?.creator} />
    </MetaDescription>
  </div>
)

export default ErrorReportMeta
